import styled from 'styled-components';
import { getSpacingToken } from '@optimus-web/common';
import { COLOR_TRANSPARENT, COLOR_WHITE, HEIGHT_ACTION_HEADER } from '../../../../components/commander-ui/constants';
import ActionMenu from './ActionMenu';

interface Props {
    actions?: $TSFixMe[];
    children?: React.ReactNode[] | React.ReactNode;
    ghost?: boolean;
}

const ActionHeader = ({ actions, children, ghost }: Props) => (
    <FlexWrapper>
        <ChildrenWrapper>{children}</ChildrenWrapper>
        {/* @ts-expect-error $TSFixMeError: JSX element type 'ActionMenu' does not have any construct or call signatures. */}
        <ActionMenu actions={actions} ghost={ghost} />
    </FlexWrapper>
);

const FlexWrapper = styled.div`
    display: flex;
`;

const ChildrenWrapper = styled.div`
    padding: 0 ${getSpacingToken('200')}px;
    height: ${HEIGHT_ACTION_HEADER};
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    &:after {
        display: inline-block;
        position: absolute;
        content: '';
        height: 100%;
        width: 16px;
        right: 0;
        background: linear-gradient(to right, ${COLOR_TRANSPARENT} 0%, ${COLOR_WHITE} 100%);
    }
`;

export default ActionHeader;
